import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { Calendar, SearchEngine } from 'plaza-react-components';

import searchChannelsQuery from '../requests/queries/searchChannels';
import searchRegularContentQuery from '../requests/queries/searchRegularContent';
import searchTagContentQuery from '../requests/queries/searchTagContent';
import searchCategoryContentQuery from '../requests/queries/searchCategoryContent.js';

import Preloader from '../shared/preloader';
import { getItem } from '../lib/localStorage';

export default function SearchPage(props) {
  const { query: keywords = '', box: type } = props.query;

  const channels = useSearchQuery(searchChannelsQuery, keywords);
  const tagContent = useSearchQuery(searchTagContentQuery, keywords);
  const regularContent = useSearchQuery(searchRegularContentQuery, keywords);
  const categoryContent = useSearchQuery(searchCategoryContentQuery, keywords);

  const { searchChannels } = channels;
  const { searchTagContent } = tagContent;
  const { searchRegularContent } = regularContent;
  const { searchCategoryContent } = categoryContent;

  const results = {
    foundTypes: [],
    totalQuantity:
      searchTagContent?.length +
      searchRegularContent?.length +
      searchChannels?.length
  };

  useEffect(() => {
    const phase = getItem('phase') || getItem('_ph');

    props.trackSearch({
      variables: {
        query: keywords,
        ...(type && { type }),
        ...(phase && { phase }),
        resultCount: results.totalQuantity || 0
      }
    });
  }, [results]);

  if (!channels || !tagContent || !regularContent || !categoryContent)
    return <Preloader />;

  if (searchTagContent?.length)
    results.foundTypes.push({
      type: 'Onderwerpen',
      quantity: searchTagContent.length,
      data: {
        list: searchTagContent,
        view: 'withoutSidebar'
      },
      component: 'articleList'
    });

  if (searchRegularContent?.length)
    results.foundTypes.push({
      type: 'Artikelen',
      quantity: searchRegularContent.length,
      data: {
        list: searchRegularContent,
        view: 'withoutSidebar'
      },
      component: 'articleList'
    });

  if (searchCategoryContent?.length)
    results.foundTypes.push({
      type: 'Categorieën',
      quantity: searchCategoryContent.length,
      data: { categories: searchCategoryContent },
      component: 'categoryList'
    });

  if (searchChannels?.length)
    results.foundTypes.push({
      type: 'Kanalen',
      quantity: searchChannels.length,
      data: { channels: searchChannels },
      component: 'channelList'
    });

  return (
    <React.Fragment>
      <Calendar nextLink={props.nextLink} />

      <SearchEngine {...props} {...results} />
    </React.Fragment>
  );
}

function useSearchQuery(query, keywords) {
  const { data, loading } = useQuery(query, {
    variables: { keywords, limit: 50 }
  });

  if (loading) return {};

  return data;
}
